import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('clinic');

RouteRegistrar.add("clinic/academics/AcademicDegrees", "academic", "academic", "مدیریت مدارک دانشگاهی");
RouteRegistrar.add("clinic/specialties/Specialties", "specialties", "specialties", "مدیریت تخصص ها ");
RouteRegistrar.add("clinic/doctors/Doctors", "doctors", "doctors", "پزشکان");
RouteRegistrar.add("clinic/visits/DoctorVisits", "visits", "visits", "ویزیت ها"); 
RouteRegistrar.add("clinic/appointments/Appointments", "appointments", "appointments", "نوبت ها");
RouteRegistrar.add("clinic/commnets/Commnets", "commnets", "commnets", "نظرات");


const routes = RouteRegistrar.allRoutes()


export default routes;
